import { sortAppointmentsByTimeAsc } from '.';

export default function getThursdayAppointmets(appointments) {
    const filterThursdayAppointments = appointments.filter(
        item => new Date(item.data.date).getDay() === 4,
    );
    return sortAppointmentsByTimeAsc(filterThursdayAppointments);
}
